"use strict";

var _classCallCheck = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _require = require("../../utils"),
    mixin = _require.mixin;

var _require2 = require("../helpers/internal-constants"),
    domSymbolTree = _require2.domSymbolTree;

var NODE_TYPE = require("../node-type");

var NodeImpl = require("./Node-impl").implementation;

var NonElementParentNodeImpl = require("./NonElementParentNode-impl").implementation;

var ParentNodeImpl = require("./ParentNode-impl").implementation;

var DocumentFragmentImpl =
/*#__PURE__*/
function (_NodeImpl) {
  _inherits(DocumentFragmentImpl, _NodeImpl);

  function DocumentFragmentImpl(args, privateData) {
    var _this;

    _classCallCheck(this, DocumentFragmentImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DocumentFragmentImpl).call(this, args, privateData));
    var host = privateData.host;
    _this._host = host;
    _this.nodeType = NODE_TYPE.DOCUMENT_FRAGMENT_NODE;
    return _this;
  } // This is implemented separately for Document (which has a _ids cache) and DocumentFragment (which does not).


  _createClass(DocumentFragmentImpl, [{
    key: "getElementById",
    value: function getElementById(id) {
      if (id === "") {
        return null;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = domSymbolTree.treeIterator(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var descendant = _step.value;

          if (descendant.nodeType === NODE_TYPE.ELEMENT_NODE && descendant.getAttributeNS(null, "id") === id) {
            return descendant;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return null;
    }
  }]);

  return DocumentFragmentImpl;
}(NodeImpl);

mixin(DocumentFragmentImpl.prototype, NonElementParentNodeImpl.prototype);
mixin(DocumentFragmentImpl.prototype, ParentNodeImpl.prototype);
module.exports = {
  implementation: DocumentFragmentImpl
};